import 'vite/modulepreload-polyfill'

// Static imports for components that are always needed
// import '@/components/example'

// Conditional imports for components that are only needed on specific pages
// This enables code splitting - components are only loaded when needed

// if (document.querySelector('test-banner-component')) {
//   import('@/components/test-banner-component').catch(console.error);
// }

// Always load suggested materials component since it's added dynamically
// Once registered, preact-custom-element will handle dynamically added instances
import('@/components/suggested-materials-component').catch(console.error);

import('@/components/choice-products-component').catch(console.error);

import('@/components/bundle-products-component').catch(console.error);

// Shop Course Materials — lazy-load when block enters viewport
const shopCourseMaterialsEls = document.querySelectorAll('shop-course-materials-component');
if (shopCourseMaterialsEls.length > 0) {
  const observer = new IntersectionObserver(
    (entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        observer.disconnect();
        console.log('[ShopCourseMaterials] Observer deactivated: block in view, loading component');
        import('@/components/shop-course-materials-component').catch(console.error);
      }
    },
    { rootMargin: '100px' }
  );
  shopCourseMaterialsEls.forEach((el) => observer.observe(el));
}
